export enum BarrierType {
    STEPPED = 'STEPPED',
    FLAT = 'FLAT',
    CUSTOM = 'CUSTOM',
    LADDER = 'LADDER',
}